module.exports = __webpack_public_path__ + "static/media/checked_box_orange.79ae045f.png";